import React, { useState } from 'react';
import './MiniChart.css';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';

const MiniChart = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    birthDate: '',
    birthTime: '',
    birthPlace: '',
    question: '',
    subscribeNewsletter: true
  });

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name || !formData.email || !formData.birthDate) {
      alert('Please fill all required fields');
      return;
    }

    try {
      const response = await fetch('https://ivyhwi60lf.execute-api.ap-south-1.amazonaws.com/prod/api/mini-chart/free', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          dateOfBirth: formData.birthDate,
          timeOfBirth: formData.birthTime || '12:00 PM',
          placeOfBirth: formData.birthPlace || 'Unknown',
          question: formData.question || '',
          subscribeNewsletter: formData.subscribeNewsletter
        })
      });

      if (response.ok) {
        alert('Your free mini chart request has been submitted! We will email it to you within 24 hours.');
        setFormData({
          name: '',
          email: '',
          birthDate: '',
          birthTime: '',
          birthPlace: '',
          question: '',
          subscribeNewsletter: true
        });
      } else {
        alert('Failed to submit request. Please try again.');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('An error occurred. Please try again later.');
    }
  };

  return (
    <div className="mini-chart-page">
      <Navigation />
      <div className="mini-chart-container">
        <h1>Get Your Free Mini Chart</h1>
        <p>Discover key insights about your personality and life path</p>

        <form onSubmit={handleSubmit} className="mini-chart-form">
          <input
            type="text"
            name="name"
            placeholder="Full Name *"
            value={formData.name}
            onChange={handleInputChange}
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Email Address *"
            value={formData.email}
            onChange={handleInputChange}
            required
          />
          <input
            type="date"
            name="birthDate"
            placeholder="Birth Date *"
            value={formData.birthDate}
            onChange={handleInputChange}
            required
          />
          <input
            type="time"
            name="birthTime"
            placeholder="Birth Time (optional)"
            value={formData.birthTime}
            onChange={handleInputChange}
          />
          <input
            type="text"
            name="birthPlace"
            placeholder="Birth Place (City, Country)"
            value={formData.birthPlace}
            onChange={handleInputChange}
          />
          <textarea
            name="question"
            placeholder="Your Question (optional)"
            value={formData.question}
            onChange={handleInputChange}
            rows="4"
            maxLength="50"
            className="mini-chart-textarea"
          />
          <label className="mini-chart-checkbox">
            <input
              type="checkbox"
              name="subscribeNewsletter"
              checked={formData.subscribeNewsletter}
              onChange={handleInputChange}
            />
            Subscribe to newsletter
          </label>
          <button type="submit" className="mini-chart-button">
            Get My Free Mini Chart
          </button>
        </form>
      </div>
      <Footer />
    </div>
  );
};

export default MiniChart;